// This helper is mainly needed because with the switch to sdx there
// is a chance that modules get loaded twice. This is specially true
// for all utility functions relying on global caching/data.
export function getGlobal(name : string, defaults : any) {

	window.scGlobals = window.scGlobals || {};
	if (!(name in window.scGlobals)) {
		window.scGlobals[name] = defaults;
	}

	return window.scGlobals[name];
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/util/globals.ts